import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DynamicConfigService } from './common/services/dynamic-config.service';
import { takeWhile } from 'rxjs';
import { RouterOutlet } from '@angular/router';

import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { APP_MODULE_ICONS } from './app-icons.module';
import { PaymentService } from './common/services/payment.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet]
})
export class AppComponent implements OnInit, OnDestroy {
  public alive: boolean;
  showEnvironmentBanner: boolean = false;
  environmentBannerMessage: string = '';
  environmentBannerColor: string = '000';
  showInfoBox: boolean;
  expandedInfoBox: boolean = true;
  constructor(
    public dynamicConfig: DynamicConfigService,
    private library: FaIconLibrary,
    // Inject PaymentService so that it will check URL params for
    // 1. tracking parameters like UTM
    // 2. a payment redirect (this happens from the buy-button widget or paywall component)
    private paymentService: PaymentService
  ) {}

  ngOnInit() {
    this.initFontAwesomeIcons();
    this.alive = true;

    this.dynamicConfig.dynamicConfig
      .pipe(takeWhile(() => this.alive))
      .subscribe(
        ({
          environment_banner_message: environmentBannerMessage,
          environment_banner_color: environmentBannerColor,
          show_environment_banner: showBanner
        }) => {
          this.environmentBannerMessage = (environmentBannerMessage ?? this.environmentBannerMessage).toUpperCase();
          this.environmentBannerColor = '#' + (environmentBannerColor ?? this.environmentBannerColor);
          this.showEnvironmentBanner = showBanner ?? this.showEnvironmentBanner;
          this.showInfoBox = this.showEnvironmentBanner;
        }
      );
  }

  initFontAwesomeIcons() {
    this.library.addIcons(...APP_MODULE_ICONS);
  }

  ngOnDestroy() {
    this.alive = false;
  }
}
